import { isAxiosError } from 'axios';
import axiosInstance from '../../utility/axiosInstance';

// types and state
import {
  setJobTypes,
  createJobType,
  updateJobType,
  setLoading,
  setUpdate
} from '@/store/slices/job_type';

// notification
import { openNotification } from '@/components/alerts/notify';
import { AppDispatch } from '@/store';

export const get_job_types = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get('/get-job-types');

    dispatch(setJobTypes(response.data));
  } catch (err) {
    if (isAxiosError(err)) dispatch(setJobTypes([]));
  }
  dispatch(setLoading());
};

type ICreateData = { name: string };
export const create_job_type = async (
  dispatch: AppDispatch,
  data: ICreateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post('/create-job-type', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(createJobType(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
    }
  }
  dispatch(setUpdate());
};

type IUpdateData = { name: string; id: string };
export const update_job_type = async (
  dispatch: AppDispatch,
  data: IUpdateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.patch('/update-job-type', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(updateJobType(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
      openNotification({
        status: 'success',
        message: err?.response?.data?.message
      });
    }
  }
  dispatch(setUpdate());
};
